import { render, staticRenderFns } from "./OrderColumnLastUpdate.vue?vue&type=template&id=0bd107a9&"
import script from "./OrderColumnLastUpdate.vue?vue&type=script&lang=ts&"
export * from "./OrderColumnLastUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports